// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToLarge":"(max-width: 959px)","BreakpointToSmall":"(max-width: 374px)","priceComparisonTable":"G92da72"};